"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6955],{

/***/ 16955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionSteps": function() { return /* binding */ SectionSteps; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75762);



const Container = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    margin: "$24 $0",
    marginTop: 0,
    gap: "68px",
    display: "flex",
    flexDirection: "column",
    "@lg": {
        margin: "$24 $30",
        marginTop: 0,
        gap: "$64"
    },
    "@xxl": {
        maxWidth: "$maxWidthDesktop",
        margin: "0 auto"
    }
});
const Title = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("h2", {
    projectFont: "heading04",
    color: "$white",
    fontSize: "34px",
    lineHeight: "110%",
    letterSpacing: "-1.02px",
    padding: "$0 $24",
    height: "37px",
    "@lg": {
        fontSize: "36px",
        letterSpacing: "-1.08px",
        height: "$40",
        padding: "$0"
    }
});
const StepsScrollContainer = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "flex",
    gap: "$20",
    overflowX: "auto",
    overflowY: "hidden",
    scrollSnapType: "x mandatory",
    padding: "$0 $20",
    scrollPadding: "$0 $20",
    "&::-webkit-scrollbar": {
        display: "none"
    },
    "@lg": {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "$20",
        overflowX: "visible",
        padding: "$0",
        scrollPadding: "$0"
    }
});
const Step = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "$32",
    alignItems: "flex-start",
    minWidth: "75vw",
    borderRadius: "$rBoxes",
    border: "1px solid #2D2D2D",
    padding: "$30",
    scrollSnapAlign: "start",
    "@lg": {
        minWidth: "auto"
    }
});
const StepNumber = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "flex",
    width: "80px",
    height: "80px",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "40px",
    border: "1px solid $white",
    projectFont: "ui02",
    color: "$white",
    textAlign: "center",
    lineHeight: "120%"
});
const StepTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("h3", {
    projectFont: "heading07",
    color: "$white",
    fontSize: "24px",
    fontWeight: 450,
    letterSpacing: "-0.24px"
});
const StepContent = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    projectFont: "heading08",
    color: "$gray300",
    fontWeight: 450,
    lineHeight: "120%",
    letterSpacing: "-0.18px",
    "& p": {
        margin: 0,
        padding: 0
    },
    "& p + p": {
        marginTop: "22px"
    }
});
const SectionSteps = (param)=>{
    let { title , steps , spacing , topBorder  } = param;
    if (!steps || steps.length === 0 || !title) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .SectionWrapper */ .Uq, {
        type: spacing || "DEFAULT",
        topBorder: topBorder,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StepsScrollContainer, {
                    children: steps.map((step, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Step, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StepNumber, {
                                    children: String(index + 1).padStart(2, "0")
                                }),
                                step.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StepTitle, {
                                    children: step.title
                                }),
                                step.content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StepContent, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .PortableText */ .YI, {
                                        value: step.content,
                                        appearance: "plain"
                                    })
                                })
                            ]
                        }, step._key))
                })
            ]
        })
    });
};


/***/ })

}]);